import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.eyebrow}>PlanScout</div>
        <h1 className={styles.title}>Report not found</h1>
        <p className={styles.body}>
          The link you followed didn't match a current report. Double-check the URL,
          or contact your advisor for a fresh link.
        </p>
      </div>
    </div>
  );
}
